import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useDebouncedCallback } from 'use-debounce'
import { assocPath } from 'ramda'

const MerchantNameFilter = ({ filter, setFilter, textEntryDebounceMs = 2000 }) => {
  // Track updates in local state for a smooth typing experience.
  const [name, setName] = useState(filter.name_cnts)

  // updateParentFilter calls the given `setFilter` based on local state, i.e. name to search for.
  const updateParentFilter = () => {
    setFilter(assocPath(['name_cnts'], name, filter))
  }

  // But only call `setFilter` debounced, so that we don't cause re-renders and API calls with every keystroke.
  const updateParentFilterDebounced = useDebouncedCallback(updateParentFilter, textEntryDebounceMs)

  // Called when the value changes
  const changed = (e) => {
    setName(e.target.value)
    updateParentFilterDebounced.callback()
  }

  // TODO: On enter, update immediately
  const keyPressed = (e) => {
    if (e.key === 'Enter') {
      updateParentFilter()
    }
  }

  return (
    <div className='filter name'>
      <input
        type='text'
        value={name || ''}
        onKeyPress={keyPressed}
        onChange={changed}
        placeholder='Filter Name'
      />
    </div>
  )
}
MerchantNameFilter.propTypes = {
  filter: PropTypes.object.isRequired,
  setFilter: PropTypes.func.isRequired,
  textEntryDebounceMs: PropTypes.number,
}

export default MerchantNameFilter
